<template>
  <ul class="public-list">
    <!-- type=sol 方案列表 -->
    <li class="sol-list-item" v-for="(item,index) in params.list" :key="index" v-if="params.type=='sol'">
      <!-- 方案热搜列表 -->
      <div class="hot-search" v-if="params.isHotSearch" @click="jumpDetail(item)">
        <div class="hot-search-left">
          <div class="item-title"><span>{{index+1}}</span>{{item.solutionName | textSlice(28)}}</div>
          <div class="item-content">{{item.description | textSlice(30)}}</div>
          <div class="item-count"><span>{{item.pageView | myriabit}}</span>阅读量</div>
        </div>
        <div class="hot-search-right">
          <img v-if="item.matchPic" :src="item.matchPic | getImageUrl">
        </div>
      </div>
      <!-- 方案列表 -->
      <div class="sol-public"  @click="jumpDetail(item)" v-else>
        <div class="sol-public-left">
          <div class="item-title">{{item.solutionName  | textSlice(30)}}</div>
          <div class="item-count"><span>{{item.pageView | myriabit}}</span>阅读量</div>
        </div>
        <div class="sol-public-right">
          <img v-if="item.matchPic" :src="item.matchPic | getImageUrl">
        </div>
      </div>
    </li>
    <!-- 资讯列表页 -->
    <li class="sol-list-item" v-for="(item, index) in params.list" :key="index" v-if="params.type=='info'">
      <div class="sol-public" @click="toNewsDetail(item.columnId)">
        <div class="sol-public-left">
          <!-- 如果需要label -->
          <div class="item-title" v-if="params.label"> <label class="info-label" v-if="item.tagName">{{item.tagName}}</label><span>{{item.columnTitle | textSlice(26)}}</span></div>
          <div class="item-title" v-else>{{item.columnTitle | textSlice(30)}}</div>
          <div class="item-count"><span>{{item.pageView | myriabit}}</span>阅读量</div>
        </div>
        <div class="sol-public-right">
          <img v-if="item.matchPic" :src="item.matchPic | getImageUrl">
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { textSlice, myriabit, getImageUrl } from '@/filters/commonFilters'
export default {
  name: 'list',
  props: ['params'],
  filters: {
    textSlice,
    myriabit,
    getImageUrl
  },
  methods: {
    // 方案详情
    jumpDetail (item) {
      this.$router.push(`/solutions/detail/${item.solutionId}.html`)
    },
    // 资讯详情
    toNewsDetail (id) {
      this.$router.push(`/news/detail/${id}.html`)
    }
  }
}
</script>

<style scoped lang="scss">

  @mixin TwoLine {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .public-list {
    background-color: #fff;
    .sol-list-item {
      padding: 15px 0;
      margin: 0 15px;
      border-bottom: 1px solid #d8d8d8;
      .hot-search {
        display: flex;
        justify-content: space-between;
        &-left {
          width: 220px;
          flex: 0 0 auto;
          .item-title {
            font-size: 14px;
            white-space: normal;
            span {
              display: inline-block;
              width: 15px;
              height: 15px;
              line-height: 16px;
              text-align: center;
              color: #fff;
              font-size: 12px;
              background: #a0a0a0;
              border-radius: 2px;
              margin-right: 4px;
              vertical-align: 1px;
            }
          }
          .item-content {
            font-size: 13px;
            color: #999;
            margin-top: 5px;
          }
          .item-count {
            margin-top: 5px;
            color: #a0a0a0;
            font-size: 10px;
            span {
              color: #f8a325;
              margin-right: 3px;
            }
          }
        }
        &-right {
          width: 110px;
          height: 75px;
          flex: 0 0 auto;
          margin-left: 15px;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      &:first-child .hot-search-left .item-title span {
        background: #f25050;
      }
      &:nth-child(2) .hot-search-left .item-title span {
        background: #faa528;
      }
      &:nth-child(3) .hot-search-left .item-title span {
        background: #9cbb2e;
      }
      .sol-public {
        display: flex;
        justify-content: space-between;
        color: #222;
        &-left {
          width: 240px;
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .info-label {
            display: inline-flex;
            outline: 1px solid #1cc0da;
            color: #1cc0da;
            padding: 1px 4px; /* no */
            position: relative;
            margin-right: 6px;
            font-size: 10px;
            align-items: center;
            bottom: 2px;
          }
          .item-count {
            color: #a0a0a0;
            font-size: 10px;
            span {
              color: #f8a325;
              margin-right: 3px;
            }
          }
        }
        &-right {
          width: 90px;
          height: 62px;
          flex: 0 0 auto;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/list.vue